import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { ManagerAutoCompleteDataModel } from "components/MprcAutoComplete/AutoCompleteDataModel";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

interface Props extends Omit<IAutoCompleteProps, 'onGetSuggestions' | 'onChange'> {
    onChange: (items: ManagerAutoCompleteDataModel[]) => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de Gerente.
 * @param props
 */
export const ManagerAutoComplete: React.FC<Props> = ({ onChange, onError, ...props }) => {

    const api = useCoreApi();

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<ManagerAutoCompleteDataModel>>((resolve) => {
            api.v1.suggestions.managers({
                searchText,
                pageNumber,
                pageSize
            }, { signal })
                .then(result => resolve({
                    items: result.data.items as ManagerAutoCompleteDataModel[],
                    totalRows: result.data.totalRows
                }))
                .catch(e => {
                    if (!isCanceledError(e)) {
                        resolve({ items: [], totalRows: 0 });
                        if (onError) onError(e);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            onError={onError}
            onGetSuggestions={getSuggestions}
            onChange={items => onChange(items as ManagerAutoCompleteDataModel[])}
        />
    );
};
